import { LESSON_QUERY_KEY } from '@/dictionary';

/**
 * Контекст урока в адресе страницы (?lesson=<id>).
 * Нужен, чтобы при переходах по разделу «Учителю и ученику» не терялся урок,
 * для которого пользователь набирает материалы.
 */
export const useLessonQuery = () => {
  const route = useRoute();

  const lessonId = computed(() => route.query[LESSON_QUERY_KEY] ?? null);

  const withLesson = (url) => {
    if (!lessonId.value) return url;

    const separator = url.includes('?') ? '&' : '?';

    return `${url}${separator}${LESSON_QUERY_KEY}=${lessonId.value}`;
  };

  return {
    lessonId,
    withLesson,
  };
};
